import React from 'react'
import Login from './pages/Login'
import Logout from './pages/Logout'
import Refresh from './pages/Refresh'
import LegalNotice from './pages/LegalNotice'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import AccessDenied from './pages/AccessDenied'
import WaitingAccess  from './pages/WaitingAccess'
import NotFound from './pages/NotFound'
import Register from './pages/Register'
import Request from './pages/Request'
import SelectApp from './pages/SelectApp'

import { BrowserRouter, Route, Switch } from 'react-router-dom'

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path='/' component={Login}/>
        <Route path='/login' component={Login} />
        <Route path='/logout' component={Logout} />
        <Route path='/refresh' component={Refresh} />
        <Route path='/legal-notice' component={LegalNotice} />
        <Route path='/privacy' component={Privacy} />
        <Route path='/terms' component={Terms} />
        <Route path='/register' component={Register} />
        <Route path='/request' component={Request} />
        <Route path='/access-denied' component={AccessDenied} />
        <Route path='/waiting-access' component={WaitingAccess} />
        <Route path='/select-app' component={SelectApp} />
        <Route component={NotFound} />
      </Switch>
    </BrowserRouter>
  )
}

export default Router